import { createFileRoute, Link, Outlet, useMatch } from "@tanstack/react-router";

import { TAB_ACTIVE_CLASS, TAB_CLASS } from "@/features/opportunities/tabs";

export const Route = createFileRoute("/stats")({ component: StatsLayout });

const TABS = [
    { to: "/stats", label: "Overview", exact: true },
    { to: "/stats/log", label: "Log", exact: false },
] as const;

function StatsLayout() {
    // A pair page has its own Overview/Log tabs; two rows of the same names would read as one.
    const onPair = useMatch({ from: "/stats/pairs/$pair", shouldThrow: false }) !== undefined;

    return (
        <div className="space-y-3 md:space-y-4">
            {!onPair && (
                <div className="flex gap-1.5" role="tablist" aria-label="Stats">
                    {TABS.map(({ to, label, exact }) => (
                        <Link
                            key={to}
                            to={to}
                            role="tab"
                            activeOptions={{ exact }}
                            className={TAB_CLASS}
                            activeProps={{
                                className: TAB_ACTIVE_CLASS,
                                "aria-selected": true,
                            }}
                        >
                            {label}
                        </Link>
                    ))}
                </div>
            )}
            <Outlet />
        </div>
    );
}
